import React, { useEffect, useState } from 'react';
import Sidebar from './components/Sidebar';
import HomePage from './pages/HomePage';
import CreationsPage from './pages/CreationsPage';
import GuidePage from './pages/GuidePage';
import ToolsPage from './pages/ToolsPage';
import VideoPage from './pages/VideoPage';
import VideoComposerPage from './pages/VideoComposerPage';
import DemoShowcasePage from './pages/DemoShowcasePage';
import StoryboardModal from './pages/StoryboardModal';
import StoryboardResultPage from './pages/StoryboardResultPage';
import FrameEditorPage from './pages/FrameEditorPage';
import ComicPage from './pages/ComicPage';
import InpaintingPage from './pages/InpaintingPage';


// --- 主应用组件 (App) ---
function App() {
  // State 切换为对象来传递数据
  const [navigation, setNavigation] = useState({ page: 'home', data: null });
  const [demoMode, setDemoMode] = useState(() => {
    const query = new URLSearchParams(window.location.search).get('demo');
    if (query === '1') return true;
    if (query === '0') return false;
    return window.localStorage.getItem('chuangshiai_demo_mode') === 'true';
  });

  const toggleDemoMode = () => {
    setDemoMode((current) => {
      const next = !current;
      window.localStorage.setItem('chuangshiai_demo_mode', String(next));
      return next;
    });
  };

  useEffect(() => {
    window.localStorage.setItem('chuangshiai_demo_mode', String(demoMode));
  }, [demoMode]);

  useEffect(() => {
    const handleShortcut = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key.toLowerCase() === 'm') {
        event.preventDefault();
        toggleDemoMode();
      }
    };
    window.addEventListener('keydown', handleShortcut);
    return () => window.removeEventListener('keydown', handleShortcut);
  }, []);

  const handleNavigate = (page, data = null) => {
    setNavigation({ page, data });
  };
  
  const currentPage = navigation.page; 

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={handleNavigate} demoMode={demoMode} />;
      case 'creations':
        return <CreationsPage onNavigate={handleNavigate} />;
      case 'guide':
        return <GuidePage onNavigate={handleNavigate} />;
      case 'tools':
        return <ToolsPage onNavigate={handleNavigate} />;
      case 'video':
        return <VideoPage onNavigate={handleNavigate} demoMode={demoMode} />;
      case 'storyboard':
        return <HomePage onNavigate={handleNavigate} demoMode={demoMode} />;
      case 'storyboard-result':
        return <StoryboardResultPage onNavigate={handleNavigate} pageData={navigation.data} />;
      case 'frame-editor':
        return <FrameEditorPage onNavigate={handleNavigate} pageData={navigation.data} />;
      case 'video-composer':
        return <VideoComposerPage onNavigate={handleNavigate} pageData={navigation.data} />;
      case 'demo-showcase':
        return <DemoShowcasePage onNavigate={handleNavigate} />;
      case 'inpainting':
        // "AI改图" 是一个全屏页面，不在此处渲染
        return null; 
      case 'comic':
        return <ComicPage onNavigate={handleNavigate} />;
      default:
        return <HomePage onNavigate={handleNavigate} demoMode={demoMode} />;
    }
  };

  // 决定是否渲染弹窗
  const renderModal = () => {
    if (currentPage === 'storyboard') {
      return <StoryboardModal onNavigate={handleNavigate} />;
    }
    return null;
  };
  
  // AI改图页是一个全屏页面，不需要侧边栏
  if (currentPage === 'inpainting') {
    return <InpaintingPage onNavigate={handleNavigate} pageData={navigation.data} />;
  }

  return (
    <div className="flex min-h-screen w-full bg-[#121212] text-gray-100 font-sans relative">
      {/* 侧边栏 */}
      <Sidebar onNavigate={handleNavigate} currentPage={currentPage} demoMode={demoMode} onToggleDemo={toggleDemoMode} />

      {/* 主内容区 */}
      <main className="flex-1 flex flex-col overflow-hidden">
        {/* 页面内容，允许滚动 */}
        <div className="flex-1 overflow-y-auto">
          {renderPage()}
        </div>
      </main>
      
      {/* 弹窗渲染 */}
      {renderModal()}
    </div>
  );
}

export default App;
